import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import PageTitle from "./PageTitleCompoent";
import "../css/AddShopScreen.css";
import component96 from "../assets/Component96.png";
import api from "../api"; // ✅ centralized API

export default function Addshopscreen() {
  const navigate = useNavigate();
  const [files, setFiles] = useState([]);
  const [, setSavedShops] = useState([]);
  const defaultProfileImg = component96;
  const [profileImg, setProfileImg] = useState(defaultProfileImg);
  const [logoFile, setLogoFile] = useState(null); // ✅ store real logo file
  const imageInputRef = useRef(null);
  const formRef = useRef(null);

  const [formData, setFormData] = useState({
    shopName: "",
    contactNumber: "",
    gstinNumber: "",
    ownerName: "",
    address: "",
    email: "",
  });

  const [errors, setErrors] = useState({});

  const handleBack = () => navigate(-1);

  // ✅ Updated: Save shop to backend with working file upload
  const handleSaveDoctor = async () => {
    const newErrors = {};
    if (!formData.shopName.trim())
      newErrors.shopName = "Please enter shop name";
    if (!formData.contactNumber.trim())
      newErrors.contactNumber = "Please enter contact number";
    if (!formData.gstinNumber.trim())
      newErrors.gstinNumber = "Please enter GSTIN number";
    if (!formData.ownerName.trim())
      newErrors.ownerName = "Please enter owner name";
    if (!formData.address.trim())
      newErrors.address = "Please enter address";
    if (!formData.email.trim()) newErrors.email = "Please enter email";

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      try {
        const data = new FormData();
        data.append("shop_name", formData.shopName);
        data.append("owner_name", formData.ownerName);
        data.append("contact_number", formData.contactNumber);
        data.append("gstin_number", formData.gstinNumber);
        data.append("address", formData.address);
        data.append("email", formData.email);

        // ✅ Append correct logo file
        if (logoFile) {
          data.append("logo", logoFile);
        }

        // ✅ Append documents (supports one or multiple)
        if (files.length > 0) {
          // ✅ If backend supports only one document
          data.append("document", files[0].file);

          // ✅ If backend supports multiple documents, uncomment below instead:
          // files.forEach((fileObj) => {
          //   data.append("document", fileObj.file);
          // });
        }

        // ✅ Debug check
        for (let [key, val] of data.entries()) {
          console.log(key, val);
        }

        const response = await api.post("/shops/add/", data, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        console.log("✅ Shop added successfully:", response.data);
        alert("Shop added successfully!");
        navigate(-1);

        // ✅ Reset form UI
        const newShop = {
          ...formData,
          profileImg,
          files,
          id: Date.now(),
        };
        setSavedShops((prev) => [...prev, newShop]);
        setFormData({
          shopName: "",
          contactNumber: "",
          gstinNumber: "",
          ownerName: "",
          address: "",
          email: "",
        });
        setFiles([]);
        setProfileImg(defaultProfileImg);
        setLogoFile(null);

        if (formRef.current) {
          formRef.current.scrollIntoView({ behavior: "smooth" });
        }
      } catch (error) {
        console.error("❌ Error adding shop:", error);
        if (error.response) {
          alert(`Failed: ${JSON.stringify(error.response.data)}`);
        } else {
          alert("Network or server error.");
        }
      }
    } else {
      const firstErrorField = Object.keys(newErrors)[0];
      const errorElement = document.getElementsByName(firstErrorField)[0];
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files).map((file, index) => ({
      id: Date.now() + index,
      name: file.name,
      size: (file.size / (1024 * 1024)).toFixed(2) + "MB",
      preview: URL.createObjectURL(file),
      file,
    }));
    setFiles([...files, ...selectedFiles]);
  };

  const handleRemove = (id) => {
    setFiles(files.filter((file) => file.id !== id));
  };

  return (
    <div className="add-shop-container" ref={formRef}>
      <Sidebar />
      <div className="add-shop-main">
        <Header />
        <div className="add-shop-content">
          <div className="add-shop-heading-row">
            <PageTitle title="Add Shop" onBack={handleBack} />
          </div>

          <div className="add-shop-card">
            <form className="add-shop-shop-form">
              <h3 className="add-shop-label1">Add New Shop</h3>
              <div className="add-shop-form-main">
                <div className="add-shop-form-row">
                  <div className="add-shop-form-group">
                    <label className="add-shop-label" style={{ height: "38px", width: "230px" }}>
                      Shop Name <span className="App-shop-required-indicator">*</span>
                    </label>
                    <input
                      type="text"
                      name="shopName"
                      value={formData.shopName}
                      onChange={handleInputChange}
                      placeholder="Enter Shop Name..."
                      className="add-shop-input"
                    />
                    {errors.shopName && (
                      <div className="add-package-error-message">{errors.shopName}</div>
                    )}
                  </div>

                  <div className="add-shop-form-group">
                    <label className="add-shop-label" style={{ height: "38px", width: "230px" }}>
                      Contact Number <span className="App-shop-required-indicator">*</span>
                    </label>
                    <input
                      type="text"
                      name="contactNumber"
                      value={formData.contactNumber}
                      onChange={handleInputChange}
                      placeholder="Enter Contact..."
                      className="add-shop-input"
                    />
                    {errors.contactNumber && (
                      <div className="add-package-error-message">{errors.contactNumber}</div>
                    )}
                  </div>

                  <div className="add-shop-form-group">
                    <label className="add-shop-label" style={{ height: "38px", width: "230px" }}>
                      GSTIN Number <span className="App-shop-required-indicator">*</span>
                    </label>
                    <input
                      type="text"
                      name="gstinNumber"
                      value={formData.gstinNumber}
                      onChange={handleInputChange}
                      placeholder="Enter GSTIN..."
                      className="add-shop-input"
                    />
                    {errors.gstinNumber && (
                      <div className="add-package-error-message">{errors.gstinNumber}</div>
                    )}
                  </div>

                  {/* ✅ Email Field */}
                  <div className="add-shop-form-group">
                    <label className="add-shop-label" style={{ height: "38px", width: "230px" }}>
                      Email <span className="App-shop-required-indicator">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Enter Email..."
                      className="add-shop-input"
                    />
                    {errors.email && (
                      <div className="add-package-error-message">{errors.email}</div>
                    )}
                  </div>
                </div>

                <div className="add-shop-form-row">
                  <div className="add-shop-form-group">
                    <label className="add-shop-label" style={{ height: "38px", width: "230px" }}>
                      Owner Name <span className="App-shop-required-indicator">*</span>
                    </label>
                    <input
                      type="text"
                      name="ownerName"
                      value={formData.ownerName}
                      onChange={handleInputChange}
                      placeholder="Enter Owner Name..."
                      className="add-shop-input"
                    />
                    {errors.ownerName && (
                      <div className="add-package-error-message">{errors.ownerName}</div>
                    )}
                  </div>

                  <div className="add-shop-form-group">
                    <label className="add-shop-label" style={{ height: "38px", width: "230px" }}>
                      Address <span className="App-shop-required-indicator">*</span>
                    </label>
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      className="add-shop-input1"
                    />
                    {errors.address && (
                      <div className="add-package-error-message">{errors.address}</div>
                    )}
                  </div>
                </div>
              </div>

              {/* ✅ Logo Upload */}
              <div className="add-shop-upload-row">
                <label className="add-shop-label-upload" htmlFor="document-upload">
                  Shop/Logo Image
                </label>
              </div>

              <div className="add-shop-upload-row">
                <div className="add-shop-upload-section">
                  <img
                    src={profileImg}
                    alt="Preview"
                    style={{ width: "68.64px", height: "69.12px", cursor: "pointer" }}
                    onClick={() => imageInputRef.current.click()}
                  />
                  <input
                    type="file"
                    ref={imageInputRef}
                    style={{ display: "none" }}
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        setProfileImg(URL.createObjectURL(file));
                        setLogoFile(file); // ✅ store real file
                      }
                    }}
                  />
                </div>
              </div>

              {/* ✅ Document Upload */}
              <div className="add-shop-upload-row">
                <div className="add-shop-upload-section1">
                  <h1 className="add-shop-label">Upload Document</h1>
                  <label htmlFor="document-upload">
                    <div className="add-shop-upload-section">
                      <label htmlFor="document-upload" className="add-shop-file-upload">
                        <div className="add-shop-upload-text">
                          Choose File
                          <input
                            type="file"
                            id="document-upload"
                            className="add-shop-upload-input"
                            multiple
                            onChange={handleFileChange}
                          />
                        </div>
                      </label>
                      <div className="add-shop-uploaded-files">
                        {files.map((file, index) => (
                          <div className="add-shop-file-preview-wrapper" key={file.id}>
                            <span className="add-shop-file-label">File {index + 1}</span>
                            <div className="add-shop-file-preview-row">
                              <div className="add-shop-file-preview">
                                <div className="add-shop-file-info-box">
                                  <img
                                    src={file.preview}
                                    alt="preview"
                                    className="add-shop-file-icon"
                                  />
                                  <div className="add-shop-file-text">
                                    <span className="add-shop-file-name">{file.name}</span>
                                    <span className="add-shop-file-size">{file.size}</span>
                                  </div>
                                </div>
                              </div>
                              <div className="add-shop-file-remove-wrapper">
                                <button
                                  className="add-shop-file-remove"
                                  onClick={() => handleRemove(file.id)}
                                  title="Remove File"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <path
                                      fill="currentColor"
                                      d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zm2-4h2V8H9zm4 0h2V8h-2z"
                                    />
                                  </svg>
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </label>
                </div>
              </div>

              {/* ✅ Save Button */}
              <div className="add-shop-save-button-wrapper">
                <button type="button" className="add-shop-Save-btn" onClick={handleSaveDoctor}>
                  <span className="add-shop-Save-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="#fff"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M12 4.5v15m7.5-7.5h-15"
                      />
                    </svg>
                  </span>
                  <span className="add-shop-Save-text"> Add Shop</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
